<p-progressBar [value]="value" />
